import {coreUrls} from "core_src/js/core_urls_config";

// Redirect order tunnel URLs to the new default order tunnel.
if (window.location.hash === '#subscribe_modal' && coreUrls.default_order_tunnel) {
    window.location.replace(coreUrls.default_order_tunnel)
}
